<template>
  <table
    id="table-package"
    class="w-full text-sm text-left text-gray-500 rtl:text-right"
  >
    <thead class="text-xs text-gray-700 uppercase bg-gray-200">
      <tr>
        <th scope="col" class="px-6 py-3">{{ $t("packages.auto.nombre") }}</th>
        <th scope="col" class="px-6 py-3">{{ $t("packages.auto.duracion") }}</th>
        <th scope="col" class="px-6 py-3">{{ $t("packages.auto.services") }}</th>
        <th scope="col" class="px-6 py-3">{{ $t("packages.auto.descripcion") }}</th>
        <th scope="col" class="px-6 py-3"></th>
      </tr>
    </thead>
    <tbody>
      <!-- eslint-disable-next-line vue/no-v-for-template-key -->
      <template v-for="item in packages" v-bind:key="item.id">
        <!-- Fila principal de la categoría -->
        <tr class="odd:bg-white even:bg-gray-50">
          <th
            scope="row"
            class="px-6 py-4 font-medium text-gray-900 whitespace-nowrap"
          >
            {{ item.name }}
          </th>
          <td class="px-6 py-4">
            {{ `${item.duration} horas` }}
          </td>
          <td class="px-6 py-4">
            <div
              class="flex flex-col justify-center gap-y-2"
              v-if="item.services.length > 0"
            >
              <span class="text-center">{{ item.services.length }}</span>
              <button
                :id="`showButton-${item.id}`"
                type="button"
                @click="showServices(item.id)"
                class="text-blue-400"
              >{{ $t("packages.auto.ver") }}</button>
              <button
                :id="`closeButton-${item.id}`"
                type="button"
                @click="closeServices(item.id)"
                class="hidden text-blue-400"
              >{{ $t("packages.auto.colapsar") }}</button>
            </div>
            <p v-else>{{ $t("packages.auto.no_hay_agregados") }}</p>
          </td>
          <td class="px-6 py-4">
            {{ item.description }}
          </td>
          <td class="px-6 py-4">
            <div class="flex gap-x-4">
              <button
                type="button"
                class="font-medium text-blue-600 hover:underline"
                @click="handleEdit(item)"
              >{{ $t("packages.auto.editar") }}</button>
              <button
                type="button"
                class="font-medium text-red-600 hover:underline"
              >{{ $t("packages.auto.borrar") }}</button>
            </div>
          </td>
        </tr>

        <!-- Fila colapsable con los items de la categoría -->
        <tr
          v-if="item.services.length > 0"
          :id="`service-item-${item.id}`"
          class="hidden"
        >
          <td class="p-4" colspan="6">
            <div
              class="grid items-center grid-cols-3 gap-4 p-4 border-t bg-slate-200"
            >
              <div
                class="flex flex-col w-full h-auto p-4 text-sm bg-white border rounded-lg gap-y-2"
                v-for="service in item.services"
                v-bind:key="service.id"
              >
                <h2 class="text-center text-eblack-900 text-md">
                  {{ service.name }}
                </h2>
                <div
                  class="flex flex-col justify-center flex-grow px-2 overflow-y-auto"
                >
                  <span
                    class="flex items-center justify-center gap-1 text-xs text-center capitalize text-eblack-500"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      class="w-3.5 h-3.5"
                    >
                      <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                      <path d="M9 11a3 3 0 1 0 6 0a3 3 0 0 0 -6 0" />
                      <path
                        d="M17.657 16.657l-4.243 4.243a2 2 0 0 1 -2.827 0l-4.244 -4.243a8 8 0 1 1 11.314 0z"
                      />
                    </svg>
                    {{
                      `${service.country}, ${service.location_one}, ${service.location_two}`
                    }}
                  </span>
                  <div class="flex justify-center gap-2 mt-2 text-xs">
                    <div
                      class="flex flex-col items-center justify-center px-4 py-1 border rounded-lg"
                    >
                      <span>{{ $t("packages.auto.comision") }}</span>
                      <span>{{ service.commission_amount }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </td>
        </tr>
      </template>
    </tbody>
  </table>
</template>

<script>
export default {
  props: ["packages", "setPackage"],
  name: "PackageTable",
  data() {
    return {
      dataTable: [],
      searchData: [],
    };
  },
  watch: {
    packages(value) {
      this.dataTable = JSON.parse(JSON.stringify(value));
      this.dataTable = this.dataTable.map((data) => {
        return {
          ...data,
          isOpen: false,
        };
      });
    },
  },
  components: {},
  methods: {
    initTable() {},
    showServices(id) {
      let closeButton = document.getElementById("closeButton-" + id);
      let showButton = document.getElementById("showButton-" + id);
      let serviceItem = document.getElementById("service-item-" + id);
      if (showButton) {
        showButton.classList.add("hidden");
      }
      if (closeButton) {
        closeButton.classList.remove("hidden");
      }
      if (serviceItem) {
        serviceItem.classList.remove("hidden");
      }
    },
    closeServices(id) {
      let closeButton = document.getElementById("closeButton-" + id);
      let showButton = document.getElementById("showButton-" + id);
      let serviceItem = document.getElementById("service-item-" + id);
      if (showButton) {
        showButton.classList.remove("hidden");
      }
      if (closeButton) {
        closeButton.classList.add("hidden");
      }
      if (serviceItem) {
        serviceItem.classList.add("hidden");
      }
    },
    handleEdit(item) {
      this.setPackage(item);
    },
  },
  created() {},
};
</script>

<style lang="scss" scoped></style>
